import { useEffect, useState } from 'react'

import { toast } from '@sales-center/components'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '@user/store/hooks'
import {
  getStatesList,
  getAllStatesProvincesList,
} from '@user/store/dictionaries'
import { selectCurrentUser } from '@user/store/authorization/userSlice'
import { TenantLocale } from '@sales-center/common'
import { useLocalizationEnabled } from '@user/store/tenantFeatures/hooks/useLocalizationEnabled'

export function useGetStatesOnMount() {
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )
  const isLocalizationEnable = useLocalizationEnabled()

  const { tenantLocale } = useSelector(selectCurrentUser)
  let locale: string | undefined = undefined

  if (isLocalizationEnable && tenantLocale == TenantLocale.USA) {
    locale = tenantLocale
  }

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        setStatus('pending')
        const result = await dispatch(getStatesList(locale))
        await dispatch(getAllStatesProvincesList())

        if (mounted) {
          if (getStatesList.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
            toast.error(`Error: States data failed to load`)
          }
        }
      } catch (err) {
        if (mounted) {
          setStatus('fail')
        }
      } finally {
        if (mounted) setStatus('idle')
      }
    }

    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}
